<template>
    <div class="flex items-start pt-4">
        <div
            class="w-10 h-10 rounded-full shrink-0 flex items-center justify-center"
            :class="{
                'bg-red-400 stroke-red-600': color == 'doc',
                'bg-blue-600 bg-opacity-10 stroke-blue-600': color == 'img',
            }"
        >
            <component
                :is="color == 'doc' ? 'IconNote' : 'IconPhotos'"
                :class="{
                    'h-4': color == 'doc',
                    'w-5 h-4': color == 'img',
                }"
            />
        </div>

        <div class="w-full pl-3">
            <div class="flex justify-between items-center pb-2">
                <p class="text-15 font-medium">{{ file.name }}</p>
                <p class="text-grey-900 text-14">{{ progress }}%</p>
            </div>
            <div
                class="w-full h-[3px] relative"
                :class="{
                    'bg-grey-400': error === false,
                    'bg-red-700': error !== false,
                }"
            >
                <div
                    class="h-[3px] absolute left-0 top-0 bg-black transition-all"
                    :style="{
                        width: progress + '%',
                    }"
                />
            </div>
            <p class="text-red-700 text-13 pt-2" v-if="error !== false">{{ error }}</p>
        </div>

        <!-- <button class='w-7 h-7 mt-2 bg-grey-300 flex items-center justify-center rounded-full'>
			<IconClose class='stroke-black w-4 h-4' />
		</button> -->
    </div>
</template>

<script>
export default {
    props: {
        file: Object,
        formData: Object,
    },

    data() {
        return {
            error: false,
            progress: 0,
            type: 'doc',
            color: '',
        }
    },

    created() {
        this._setExtensionFromFile()
        this.upload()
    },

    methods: {
        upload() {
            this.$axios
                .upload('/upload', this.formData, {
                    onUploadProgress: (progressEvent) => {
                        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    },
                })
                .then((res) => {
                    // this.$refs.modal.close()
                    this.$emit('uploaded')
                })
                .catch((error) => {
                    // console.log(error)
                    // a.progress = 0;
                    this.$emit('error', error.response.data.message)
                    this.error = error.response.data.message
                })
        },

        _setExtensionFromFile() {
            let ext = this.file.name.split('.')

            if (ext.length != 0) {
                ext = ext[ext.length - 1]

                this.color = ['ai', 'jpg', 'png', 'jpeg', 'svg', 'gif'].indexOf(ext) >= 0 ? 'img' : 'doc'
            }
        },
    },
}
</script>
